import React from 'react';
import MedicalSection from './medical/MedicalSection';

const Medical = () => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">Medical Certificates</h2>
      <MedicalSection />
    </div>
  );
};

export default Medical; 